import { defineComponent } from "vue";
import type { IBaseComponentProps } from "../base/types";
import { defineVariants } from "@/utils/style/variant";

type CircleProps = IBaseComponentProps & {
  size?: 's' | 'm' | 'xs';
}

const useVariants = defineVariants({
  slots: {
    base: {
      class: 'w-12 h-12 bg-green-200 rounded-full justify-center items-center inline-flex transition-all',
      style: {
        pointerEvents: 'all'
      }
    }
  },
  variants: {
    color: {
      success: {
        base: {
          class: 'bg-green-200 text-green-500'
        }
      },
      emerald600: {
        base: {
          class: 'bg-emerald-500 text-white'
        }
      },
      error: {
        base: {
          class: 'bg-red-200 text-red-500'
        }
      },
      primary: {
        base: {
          class: 'bg-findex-500 text-white'
        }
      },
      auto: {
        base: (props) => ({
          class: 'bg-inherit transition-all',
          style: {
            boxShadow: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.25)'
          },
          hover: {
            style: {
              boxShadow: props.disabled ? '' : '0 2px 4px 0 rgb(0 0 0 / 0.25)',
            }
          }
        })
      }
    },
    size: {
      xs: {
        base: {
          class: 'w-4 h-4 p-1',
        }
      },
      m: {
        base: {
          class: ''
        }
      },
      s: {
        base: {
          class: 'w-8 h-8'
        }
      }
    },
    disabled: {
      true: {
        base: {
          style: {
            opacity: '20%'
          }
        }
      }
    }
   // hover: {
   //   true: {
   //     base: {
   //       class: 'bg-white'
   //     }
   //   }
   // },
  }
});

//const CircleClass = tv({
//  base: 'w-12 h-12 bg-green-200 rounded-full justify-center items-center inline-flex',
//  variants: {
//    color: {
//      success: 'bg-green-200 text-green-500',
//      error: 'bg-red-200 text-red-500',
//      primary: 'bg-findex-500 text-white',
//      auto: 'bg-inherit shadow-[0_35px_60px_-15px_rgba(1,0,0,0.9)]'
//    },
//    size: {
//      m: '',
//      s: 'w-8 h-8'
//    }
//  }
//})

const Circle = defineComponent<CircleProps>({
  setup(props, ctx) {
    const classes = useVariants({ color: props.variant as any, size: props.size as any, disabled: !!props.disabled });
    return () => {
      const base = classes.value.base;
      return <div ref={base.ref} class={base.class} style={base.style}>{ctx.slots.default ? ctx.slots.default() : ''}</div>
    }
  }
});

Circle.props = ['variant', 'size', 'disabled'];

export default Circle;
